<div
  class="menuBackdrop"
  [ngClass]="{
    'menuBackdrop--visible': ppSidePanel.expanded,
    'menuBackdrop--visible-desktop': ppSidePanel.notificationsExpanded,
  }"
  (click)="closePanel()"
></div>
